import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

interface IProps {
    onClose: () => void;
}

interface IState {}

// 微信二维码
class WxModal extends BaseComponent<IProps, IState> {
    render() {
        const { onClose } = this.props;
        return (
            <div className="we-modal">
                <div className="modal-content">
                    <div className="btn-close" onClick={onClose}></div>
                    <div className="pic-wx"></div>
                    <div className="wx-text">关注《我自为道》公众号</div>
                </div>
            </div>
        );
    }
}

export default WxModal;
